class TermsModal extends ModalDialog {
    constructor() {
        super();
        this.querySelector('[id^="ModalConfirm-"]').addEventListener('click', this.confirm.bind(this, false));
    }

    confirm() {
        const tag1Terms = this.querySelector('#product-tag1-terms');
        const tag2Terms = this.querySelector('#product-tag2-terms');

        if ((!tag1Terms || tag1Terms?.checked) && (!tag2Terms || tag2Terms?.checked)) {
            this.hide();
        }
    }
}

customElements.define('terms-modal', TermsModal);